import React from 'react';

interface DefaultFlags {
    [key: string]: boolean;
}

const DefaultFeatureFlagsContext = React.createContext<DefaultFlags>({});

export default DefaultFeatureFlagsContext;
